<template>
    <div class="ethos-section" id="ethos">
        <v-row id="ethos" style="background-color:#72d2f6;min-height:100vh">
            <v-col cols="1"></v-col>
            <v-col cols="10">
                <v-row style="">
                    <v-col cols="12">
                        <h2 class="header-watermark">ethos</h2>
                    </v-col>
                </v-row>
                <v-row style="">
                    <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3" class="info-col-padding">
                        <KinesisContainer>

                            <KinesisElement tag="img" src="/img/flexible.jpg" :strength="isMobile() ? 0 : 20"
                                style="width:100%;margin-left:0px" type="depth" />

                            <KinesisElement tag="h3" type="depth" :strength="isMobile() ? 0 : 20" style="margin-top:0px">
                                Flexible</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : 10">Yes, we are a start-up, but that makes
                                us flexible and willing to explore new ideas</KinesisElement>

                        </KinesisContainer>
                    </v-col>

                    <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3" class="info-col-padding">
                        <KinesisContainer>

                            <KinesisElement tag="img" src="/img/creative.jpg" :strength="isMobile() ? 0 : 20"
                                style="width:100%;margin-left:0px" type="depth" />

                            <KinesisElement tag="h3" type="depth" :strength="isMobile() ? 0 : 20">Creative</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : 10">We design and build our own IOT
                                devices, software and firmware and are capable of creating targeted fit for purpose systems
                            </KinesisElement>



                        </KinesisContainer>
                    </v-col>

                    <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3" class="info-col-padding">
                        <KinesisContainer>

                            <KinesisElement tag="img" src="/img/partner.jpg" :strength="isMobile() ? 0 : 20"
                                style="width:100%;margin-left:0px" type="depth" />

                            <KinesisElement tag="h3" type="depth" :strength="isMobile() ? 0 : 20">Partner</KinesisElement>

                            <KinesisElement tag="h3" type="depth" :strength="isMobile() ? 0 : 20">Orientated
                            </KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : 10">Our hardware and software products are
                                primed for white labelling. We welcome OEM agreements</KinesisElement>

                        </KinesisContainer>
                    </v-col>


                    <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="3" class="info-col-padding">
                        <KinesisContainer>


                            <KinesisElement tag="img" src="/img/research.jpg" :strength="isMobile() ? 0 : 20"
                                style="width:100%;margin-left:0px" type="depth" />

                            <KinesisElement tag="h3" type="depth" :strength="isMobile() ? 0 : 20">Research</KinesisElement>

                            <KinesisElement tag="h3" type="depth" :strength="isMobile() ? 0 : 20">Centered</KinesisElement>

                            <KinesisElement tag="h4" :strength="isMobile() ? 0 : 10">We are continuously keeping our finger
                                on the pulse of the latest developments in machine learning and AI Edge runtime systems
                            </KinesisElement>

                        </KinesisContainer>
                    </v-col>
                </v-row>

            </v-col>

            <v-col cols="1"></v-col>
        </v-row>
    </div>
</template>

<script>
import { KinesisContainer, KinesisElement } from 'vue-kinesis'

export default {
    components: {
        KinesisContainer,
        KinesisElement
    },
    data: () => ({
        carouselItem: 0,
        selectedPortfolio: null,
        showDialog: false,
        portfolio: [
            {
                files: [
                    '/img/easefica-1.png',
                    '/img/easefica-2.png',
                    '/img/easefica-3.png',
                    '/img/easefica-4.png',
                ]
            },
            {
                files: [
                    '/img/easefica-admin-1.png',
                    '/img/easefica-admin-2.png',
                    '/img/easefica-admin-3.png',
                    '/img/easefica-admin-4.png',
                ]
            },
            {
                files: [
                    '/img/loomiot-1.png',
                    '/img/loomiot-2.png',
                    '/img/loomiot-3.png',
                ]
            }
        ]
    }),
    methods: {
        isMobile() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        selectPortfolio(p) {
            this.selectedPortfolio = p;
            this.carouselItem = 0;
            this.showDialog = true;
        },
        closePortfolio() {
            this.selectedPortfolio = null;
            this.carouselItem = 0;
            this.showDialog = false
        }
    }
}
</script>

<style scoped>
.watermark-black {
    font-size: 256px;
    font-family: "Walkway Black";
    font-weight: lighter;
    line-height: 280px;
    margin-top: 32px;
    color: rgba(255, 255, 255, 0.05);
    max-width: 100%;
    overflow: hidden;
}

.header-watermark {
    font-size: 256px;
    font-family: "Walkway Black";
    font-weight: lighter;
    line-height: 280px;
    overflow: hidden;
    color: rgba(0, 0, 0, 0.05);
    margin-bottom: -100px;
    margin-top: 64px;
}

.carousel-view {
    height: 80vh;
    width: 80vw;
    border-radius: 5px;
    z-index: 100;
}

.close-button {

    background-color: white;
}

.portfolio-list {
    margin-top: 32px;
}

.portfolio-item {
    position: relative;
    margin-top: 120px;
    min-height: 50vh;
    cursor: pointer;
}

.web-section {
    position: relative;
    background-color: #111111;
    min-height: 100vh;
    width: auto;
    background: url('/img/bg2.jpg');
    background-size: cover
}

.web-heading {
    position: absolute;
    width: 100%;
    top: 0%
}

@media (max-width: 1020px) {
    .portfolio-item {
        position: relative;
        margin-top: 120px;
        min-height: 40vh;
        cursor: pointer;
    }

    .header-watermark {
        font-size: 200px;
        font-family: "Walkway Black";
        font-weight: lighter;
        line-height: 280px;
        overflow: hidden;
        color: rgba(0, 0, 0, 0.05);
        margin-bottom: -100px;
        margin-top: 0px;
    }

    h3 {
        font-family: "Walkway Black", Helvetica, Arial;
        font-size: 32px;
        font-weight: lighter;
        line-height: 40px;
    }

    h4 {

        font-size: 20px;
        font-weight: lighter;
        line-height: 28px;
        margin-top: 8px;
        margin-bottom: 16px;
    }
}

@media (max-width: 600px) {
    .portfolio-item {
        position: relative;
        margin-top: 32px;
        min-height: 25vh;
        cursor: pointer;
    }

    .header-watermark {
        font-size: 128px;
        font-family: "Walkway Black";
        font-weight: lighter;
        line-height: 280px;
        overflow: hidden;
        color: rgba(0, 0, 0, 0.05);
        margin-bottom: -100px;
        margin-top: 0px;
    }

    h3 {
        font-family: "Walkway Black", Helvetica, Arial;
        font-size: 32px;
        font-weight: lighter;
        line-height: 40px;
    }

    h4 {

        font-size: 20px;
        font-weight: lighter;
        line-height: 28px;
        margin-top: 8px;
        margin-bottom: 16px;
    }
}
</style>